const log = (v) => { console.log(v); return v };
export default log



/** WEBPACK FOOTER **
 ** ./app/utils/log.js
 **/